function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSezione05Popup0301Ico03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98.42 70.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M86.55,10.12s-12.32,5.54-17.34,7.18M98.14,46.12l-18.76,5.99",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.47,21.93c-1.04-8.13-13.99-10.72-21.13-11.98-8.17-1.44-12.74-5.15-15.52-7.09-2.12-1.48-3.52-2.45-4.99-1.69-2.06,1.05-3.3,4.35-2.85,7.5.34,2.32,1.9,6.58,8.48,9.07.11.05.24.1.36.15l-25.87,3.82c-2.78.41-5.46,3.06-4.94,6.63.22,1.55,1.04,2.9,2.29,3.84,1.25.93,2.79,1.32,4.34,1.09l15.96-2.34-21.7,3.21c-2.79.4-5.45,3.1-4.93,6.68.47,3.19,3.44,5.39,6.62,4.93l22.19-3.25-19.04,2.8c-2.78.41-5.46,3.06-4.94,6.63.23,1.54,1.06,2.98,2.31,3.91,1.26.93,2.79,1.31,4.34,1.09l19.26-2.83-11.54,1.7c-2.59.38-5.08,2.85-4.59,6.18.43,2.97,3.21,5.1,6.17,4.67l6.52-.96",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.07,43.22c-5.48,0-9.92-4.44-9.92-9.92s4.44-9.92,9.92-9.92,9.92,4.44,9.92,9.92-4.44,9.92-9.92,9.92ZM50.28,46.12c0,4.09-3.31,7.4-7.4,7.4s-7.4-3.31-7.4-7.4,3.32-7.4,7.4-7.4,7.4,3.31,7.4,7.4ZM32.67,70.37v-5.18c0-4.78,4.57-7.51,10.21-7.51s10.22,2.74,10.22,7.51v5.18M78.2,70.37v-9.99c0-8.02-7.67-12.61-17.13-12.61-3.61,0-5.46.65-5.46.65",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.83px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezione05Popup0301Ico03);
export default __webpack_public_path__ + "static/media/sezione-05-popup-03-01-ico-03.f1892e1d87d044ceb266e1c347ef25e3.svg";
export { ForwardRef as ReactComponent };